import { Expose, Type, Exclude } from "class-transformer";

import { PartnerModel } from '@saliente/common-partners';

export class ClientPartnerContactModel {
	public personTitleCode: string;
	public personTitleName: string;
	public firstName: string;
	public lastName: string;
	public phoneNumber: string;
	public email: string;
	public isActive: boolean = true;

	get emailDisplay(): string {
		return `${this.firstName} ${this.lastName}<${this.email}>`
	}

	static typeProvider() {
		return ClientPartnerContactModel;
	}

}

export class ClientPartnerCurrencyRateModel {
	public externalId: string;
	public currencyCode: string;
	public extraPercent: number;
	public referenceBank: string;

	static typeProvider() {
		return ClientPartnerCurrencyRateModel;
	}
}

export class ClientPartnerIbanModel {
	bankName: string;
	currencyCode: string;
	externalId: string;
	iban: string;
	displayOrder: number;

	static typeProvider() {
		return ClientPartnerIbanModel;
	}
}


export class PartnerClientGridListModel {
    public recordsCount: number;
    public first: number;
    public last: number;
    public pageSize: number;
    public data: ClientPartnerListModel[];
}

export class ClientPartnerListModel {
	public externalId: string;
	public partnerExternalId: string;

	public isLegalPerson: boolean;
	public legalPersonType: string;
	public partnerName: string;
	public fiscalNumber: string;
	public registrationNumber: string;
	public creditTerm: number;

	public countryCode: string;
	public countryName: string;
	public region: string;
	public taxCode: string;
	public taxAttribute: string;

	@Expose({ name: 'partnerClientContacts' })
	@Type(ClientPartnerContactModel.typeProvider)
	public contacts: ClientPartnerContactModel[] = [];
}

export class ClientPartnerModel {
	public externalId: string;
	public clientExternalId: string;
	public partnerExternalId: string;
	public creditTerm: number;
	public invoicingDetails: string
	public communicationLanguage: string;

	public countryCode: string;
	public countryName: string;
	public region: string;
	public taxCode: string;
	public taxAttribute: string;

	@Type(PartnerModel.typeProvider)
	//@Exclude({ toPlainOnly: true })
	public partner: PartnerModel;

	@Expose({ name: 'partnerClientContacts' })
	@Type(ClientPartnerContactModel.typeProvider)
	public contacts: ClientPartnerContactModel[] = [];

	@Expose({ name: 'partnerClientRates' })
	@Type(ClientPartnerCurrencyRateModel.typeProvider)
	public rates: ClientPartnerCurrencyRateModel[] = [];

	@Expose({ name: 'partnerClientIbans' })
	@Type(ClientPartnerIbanModel.typeProvider)
	public ibans: ClientPartnerIbanModel[] = [];

	@Exclude()
	public isNewPartner: boolean = false;
}

export class SysSaftPartnerPrefixModel {
	public code: string;
	public description: string;
	public userSelectable: boolean;

	@Exclude()
	public get fullDescription(): string {
		return `${this.code} - ${this.description}`;
	}
}